import React from 'react';
import { Joyride } from 'react-joyride';
import { TOUR_STEPS } from './tourSteps';
import { TourTooltip } from './TourTooltip';
import { TOUR_THEME } from './tourTheme';

export function ProductTour({ run, onCallback, steps = TOUR_STEPS }) {
  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      scrollToFirstStep={false}
      tooltipComponent={TourTooltip}
      floatingOptions={{ hideArrow: true }}
      onEvent={onCallback}
      locale={{
        back: 'Atrás',
        close: 'Cerrar',
        last: 'Finalizar',
        next: 'Siguiente',
        skip: 'Saltar tour',
      }}
      options={{
        skipScroll: true,
        zIndex: 10000,
        overlayColor: TOUR_THEME.overlay,
        primaryColor: TOUR_THEME.accent,
        backgroundColor: TOUR_THEME.panelBgSolid,
        textColor: TOUR_THEME.textPrimary,
        spotlightPadding: 6,
        spotlightRadius: TOUR_THEME.borderRadius,
        buttons: ['skip', 'back', 'primary'],
      }}
      styles={{
        overlay: {
          mixBlendMode: 'normal',
        },
        floater: {
          overflow: 'visible',
        },
        tooltip: {
          padding: 0,
          borderRadius: TOUR_THEME.borderRadius,
          overflow: 'visible',
        },
        tooltipContainer: {
          textAlign: 'left',
        },
      }}
    />
  );
}
